(function () {
  'use strict';

  angular
    .module('crewAirportExpiryReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('crewAirportExpiryReport', {
        url: '/crew-airport-expiry-report',
        views:{
          'crewAirportExpiryReportView': {
            templateUrl: 'crew-airport-expiry-report/views/crew-airport-expiry-report.tpl.html',
            controller: 'CrewAirportExpiryReportCtrl',
            controllerAs: 'crewAirportExpiryReport'
          }
        }
      });
  }
}());
